import React from 'react';

import { SVGComponentProps } from './svg.types';

const ArchiveSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSVGProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSVGProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM8.85952 6.32223C9.89323 6.32223 10.7312 5.48257 10.7312 4.4468C10.7312 3.41103 9.89323 2.57137 8.85952 2.57137C7.82582 2.57137 6.98784 3.41103 6.98784 4.4468C6.98784 5.48257 7.82582 6.32223 8.85952 6.32223ZM11.0116 13.0711C10.8627 13.0711 10.7198 13.0119 10.6145 12.9065C10.5091 12.8011 10.4498 12.658 10.4496 12.5088V8.22313C10.4496 8.074 10.3904 7.93098 10.2852 7.82553C10.18 7.72008 10.0372 7.66084 9.88839 7.66084H6.99019C6.84136 7.66084 6.69862 7.72008 6.59338 7.82553C6.48814 7.93098 6.42902 8.074 6.42902 8.22313V8.59855C6.42902 8.74768 6.48814 8.8907 6.59338 8.99615C6.69862 9.1016 6.84136 9.16084 6.99019 9.16084C7.13902 9.16084 7.28175 9.22008 7.38699 9.32553C7.49223 9.43098 7.55135 9.574 7.55135 9.72313V12.5131C7.55135 12.6623 7.49223 12.8053 7.38699 12.9107C7.28175 13.0162 7.13902 13.0754 6.99019 13.0754C6.84136 13.0754 6.69862 13.1347 6.59338 13.2401C6.48814 13.3455 6.42902 13.4886 6.42902 13.6377V14.0131C6.43015 14.1615 6.48977 14.3034 6.59489 14.408C6.7 14.5125 6.84209 14.5711 6.99019 14.5711H11.0107C11.0844 14.5711 11.1574 14.5566 11.2255 14.5283C11.2935 14.5001 11.3554 14.4586 11.4075 14.4064C11.4596 14.3542 11.501 14.2922 11.5292 14.224C11.5574 14.1558 11.5719 14.0827 11.5719 14.0088V13.6334C11.5719 13.4844 11.5129 13.3415 11.4078 13.2361C11.3028 13.1307 11.1603 13.0714 11.0116 13.0711Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ArchiveSVG;
